module.exports = __webpack_public_path__ + "img/service-paquete.06e42d62.svg";